import { getImageUrl } from '../utils/imageLoading';

export const donationDefaultAmounts = [25, 50, 100];

function setPartnerLogoUrl(action) {
    if (action.partner == null || action.partner.logoId == null) return action;

    return {
        ...action,
        partner: {
            ...action.partner,
            logoUrl: `${getImageUrl(action.partner.logoId)}`
        }
    };
}

function processDonation(action) {
    return {
        ...action,
        partner: {
            ...action.partner,
            paymentMethod: action.partner.paymentType
        },
        amounts:
            action.oneCardCustomAmounts != null && action.oneCardCustomAmounts.length
                ? action.oneCardCustomAmounts
                : donationDefaultAmounts
    };
}

const normalizeRecipientPictureIds = action => {
    // combines recipient images from pictureId, recipientPictureIds, and recipientPictureIds keys
    // and returns values as array
    if (
        action.recipientPictureIds === undefined &&
        action.recipientPictureId === undefined
    ) {
        return !!action.pictureId ? Array.from([action.pictureId]) : [];
    } else {
        if (!!action.recipientPictureId) return Array.from([action.recipientPictureId]);
        if (!!action.recipientPictureIds) return Array.from(action.recipientPictureIds);
        return [];
    }
};

export default function processData(data, savedState) {
    const actions = data.actions.map(a => {
        let action = {
            ...a,
            identifier: `${a.id}|${a.type}`,
            type: a.type.toLowerCase(),
            recipientPictureIds: normalizeRecipientPictureIds(a)
        };

        if (action.type === 'donation') {
            action = processDonation(action);
        }

        action = setPartnerLogoUrl(action);
        return action;
    });
    let activeAction = actions[0];
    if (savedState) {
        activeAction =
            actions.find(
                a =>
                    a.type === savedState.actionType.toLowerCase() &&
                    a.actionId === savedState.widgetActionId
            ) || activeAction;
    }
    const cards = data.cards.map(c => setPartnerLogoUrl(c));
    const pictures = actions
        .filter(action => !!action.recipientPictureIds)
        .concat(data.cards.filter(card => !!card.recipientPictureIds))
        .map(obj => obj.recipientPictureIds)
        .map(recipientPictureIds => ({
            recipientPictureIds,
            pictureUrls: recipientPictureIds.map(pid => `${getImageUrl(pid)}`)
        }));

    const processedAction = {
        ...data,
        actions,
        activeAction,
        cards,
        pictures,
        publisherLogoUrl: getImageUrl(data.publisherLogoName)
    };

    return processedAction;
}
